import React from 'react';
import { SidedCrudStore } from '../sided-crud-store';
import { Content, Render, Row, Spacer } from '@gower/react-ui/components';
import { TemplatesProps } from './view.props';
import { getActions } from './view.actions';
import { Header } from './components/header';
import { ContentLoader } from './components/content-loader';

export type ViewProps = TemplatesProps &
{
    crudStore: SidedCrudStore;
};
export const ViewTemplate: React.FC<ViewProps> = ( { ...props } ) =>
{
    const store = props.crudStore.ViewStore;

    return <>
        {props.template && <Render content={props.template} props={{ ...props.injectProps, ...store.getProps(), ...getActions( { store, ...props } ) }} />}
        {!props.template && <>
            <Content width="100%" height="100%" color="white" noScroll>
                <Content columns fullWidth fullHeight scrollOnlyVertical>
                    <Header {...props} store={store} />
                    <Spacer paddingX={15}>
                        <Row maxWidth={props.maxWidth}>
                            <ContentLoader {...props} store={store}>
                                {store.isEditing && props.editContent && <Render content={props.editContent} props={{ ...props.injectProps, ...store.getProps(), ...getActions( { store, ...props } ) }} />}
                                {( !store.isEditing || !props.editContent ) && <Render content={props.content} props={{ ...props.injectProps, ...store.getProps(), ...getActions( { store, ...props } ) }} />}
                            </ContentLoader>
                        </Row>
                    </Spacer>
                </Content>
            </Content>
        </>}
    </>;
};